"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var current_node_view_component_1 = __importDefault(require("./current-node-view.component"));

var scenario_selectors_1 = require("../../redux/scenario/scenario.selectors");

var CurrentNodeViewContainer = function CurrentNodeViewContainer() {
  var currentNodeId = react_redux_1.useSelector(scenario_selectors_1.selectCurrentNodeId);
  var node = react_redux_1.useSelector(scenario_selectors_1.getSelectNode(currentNodeId));

  if (!node) {
    console.warn("node with given currentNodeId does not exist !!! currentNodeId >>>> ".concat(currentNodeId));
    return null;
  }

  return react_1.default.createElement(current_node_view_component_1.default, {
    nodeId: currentNodeId,
    node: node
  });
};

exports.default = CurrentNodeViewContainer;